import { render, staticRenderFns } from "./UrlsList.vue?vue&type=template&id=27ba3f26&scoped=true"
import script from "./UrlsList.vue?vue&type=script&lang=js"
export * from "./UrlsList.vue?vue&type=script&lang=js"
import style0 from "./UrlsList.vue?vue&type=style&index=0&id=27ba3f26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba3f26",
  null
  
)

export default component.exports